import React, { FC } from 'react';
import { Note } from 'components/ui';
import { hexColorRegex, t } from 'utils';

import styles from './AppIcon.module.scss';
import { Field } from 'react-final-form';
import { ColorSelectWrapper, TextInputWrapper } from 'components/forms';
import classNames from 'classnames';
import { IAppIcon } from './AppIcon';

const NAME_MAX_LIMIT = 3;

const AppIconFontAwesome: FC<IAppIcon> = ({
  iconTextColor,
  disabled,
  abbreviatedName,
  iconBackgroundColor,
}) => {
  const isValidBackgroundColor = hexColorRegex.test(iconBackgroundColor);
  const isValidTextColor = hexColorRegex.test(iconTextColor);
  const defaultBackgroundColor = '#E5E6E7';
  const defaultTextColor = '#FFFFFF';
  const bgColorToUse = isValidBackgroundColor ? iconBackgroundColor : defaultBackgroundColor;

  return (
    <div className={styles['ta-app-icon__form']}>
      <div
        className={classNames(
          styles['ta-app-icon__form__icon-preview'],
          styles['ta-app-icon__form__icon-preview__text'],
          {
            [styles['ta-app-icon__form__icon-preview__white']]: ['#fff', '#ffffff'].includes(
              bgColorToUse.toLowerCase()
            ),
          }
        )}
        style={{
          backgroundColor: bgColorToUse,
        }}
      >
        <span style={{ color: isValidTextColor ? iconTextColor : '#ffffff' }}>
          {abbreviatedName}
        </span>
      </div>
      <Field
        name='abbreviatedName'
        component={TextInputWrapper}
        disabled={disabled}
        required
        addon={
          <span className={styles['ta-app-icon__form__input__addon']}>
            {abbreviatedName.length}/{NAME_MAX_LIMIT}
          </span>
        }
        label='app.icon.box.default.name.label'
        placeholder='app.icon.box.default.name.placeholder'
        className={styles['ta-app-icon__form__input']}
        maxLength={3}
        parse={(value) => value} // needed because if deleted, final-form does not pass the empty srting
      />
      <Field
        name='iconBackgroundColor'
        component={ColorSelectWrapper}
        disabled={disabled}
        defaultColor={defaultBackgroundColor}
        label='app.icon.box.fontawesome.background.label'
        placeholder='app.icon.box.fontawesome.background.placeholder'
        className={styles['ta-app-icon__form__input']}
        parse={(value) => value}
      />
      <Field
        name='iconTextColor'
        component={ColorSelectWrapper}
        disabled={disabled}
        defaultColor={defaultTextColor}
        label='app.icon.box.fontawesome.color.label'
        placeholder='app.icon.box.fontawesome.color.placeholder'
        className={styles['ta-app-icon__form__input']}
        parse={(value) => value}
      />
      <Note className={styles['ta-app-icon__form__note']}>
        <span
          dangerouslySetInnerHTML={{
            __html: t('app.icon.default.hint'),
          }}
        />
      </Note>
    </div>
  );
};

export default AppIconFontAwesome;
